module.exports = __webpack_public_path__ + "static/media/yo_img.31752463.png";